import '.a8{width:100%;}.ssr-plugin'
import '.cj{max-width:100%;}.ssr-plugin'
import '.ck{margin-left:0px;}.ssr-plugin'
import '.cl{margin-right:0px;}.ssr-plugin'
import '.b3{margin-bottom:2rem;}.ssr-plugin'
import '.v{height:auto;}.ssr-plugin'
import '.n{overflow:hidden;}.ssr-plugin'
import '.cm{width:auto;}.ssr-plugin'
import '.cn{display:block;}.ssr-plugin'
import '.co{overflow-wrap:break-word;}.ssr-plugin'
import '.cp{word-break:break-word;}.ssr-plugin'
import sanitizeHtml from 'sanitize-html'
import parse, { DOMNode, domToReact, Element } from 'html-react-parser'
import React from 'react'
import { Title } from '../typography/Title'
import { Paragraph } from '../typography/Paragraph'
import { UnorderedList } from '../typography/UnorderedList'
import { Quote } from '../typography/Quote'
import { styled } from 'inlines'

type ComponentMap = {
  [tagName: string]: React.ComponentType<any>
}

interface SafeHtmlProps {
  html: string
  components?: ComponentMap
}

const Figure = ({ children }: { children: React.ReactNode }) => {
  return (
    <styled.figure className="a8 cj ck cl b3 v n"
      style={{
        '& > img': {
          width: '100%',
          maxWidth: '100%',
          height: 'auto',
          borderRadius: '1.25rem',
          display: 'block',
        },
      }}
    >
      {children}
    </styled.figure>
  )
}

const defaultComponents: ComponentMap = {
  h1: ({ children }) => <Title.H1>{children}</Title.H1>,
  h2: ({ children }) => <Title.H2>{children}</Title.H2>,
  h3: ({ children }) => <Title.H3>{children}</Title.H3>,
  h4: ({ children }) => <Title.H4>{children}</Title.H4>,
  h5: ({ children }) => <Title.H5>{children}</Title.H5>,
  p: ({ children }) => <Paragraph.Medium>{children}</Paragraph.Medium>,
  //   a: ({ href, children }) => (
  //     <a
  //       href={href}
  //       target="_blank"
  //       rel="noopener noreferrer"
  //       className="text-blue-600 underline"
  //     >
  //       {children}
  //     </a>
  //   ),
  ul: ({ children }) => <UnorderedList>{children}</UnorderedList>,
  blockquote: ({ children }) => <Quote>{children}</Quote>,
  strong: ({ children }) => <strong>{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
  figure: ({ children }) => <Figure>{children}</Figure>,
  img: ({ src, alt }) => (
    <img className="cj cm v cn"
      src={src}
      alt={alt}
    />
  ),
}

export function SafeHtml({ html, components = {} }: SafeHtmlProps) {
  const mergedComponents = {
    ...defaultComponents,
    ...components,
  }

  const cleanHtml = sanitizeHtml(html, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat([
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'img',
      'figure',
    ]),
    allowedAttributes: {
      '*': ['class'],
      a: ['href', 'target', 'rel'],
      img: ['src', 'alt'],
    },
    allowedSchemes: ['http', 'https', 'mailto'],
  })

  return (
    <div className="a8 cj co cp"
    >
      {parse(cleanHtml, {
        replace: (node) => {
          if (node instanceof Element) {
            const Component = mergedComponents[node.name]
            if (Component) {
              return (
                <Component {...node.attribs}>
                  {domToReact(node.children as DOMNode[])}
                </Component>
              )
            }
          }
        },
      })}
    </div>
  )
}
